import Arrow from "@assets/icons/arrow-right.svg";
import { Battery } from "@components/battery";
import { Block } from "@components/block";
import { Button } from "@components/button";
import { FilterConfig } from "@components/filter-modal";
import { StatusBlock, StatusBlockType } from "@components/status-block";
import { Config, DoubleText, Table } from "@components/table";
import { useDevices } from "@features/device";
import { DevicesDescriptionForm } from "@features/device/api";
import { DeviceType } from "@features/device/slice";
import { formatDate, formatTime } from "@helpers/date";
import { useBoolState } from "@hooks/use-bool-state";
import { usePagination } from "@hooks/use-pagination";
import { useUrlFilters } from "@hooks/useUrlFilters";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AddDeviceModal } from "./add-device-modal";
import styles from "./devices.module.scss";
// import { useWebSocket } from "@request/useWebsocket";
// import { WebsocketUpdateType } from "@request/websocket";

const config: Config<DeviceType> = [
  { label: "Название устройства", source: "name" },
  { label: "Версия APK", source: "app_version" },
  { label: "Номер телефона", source: "phone_number" },
  {
    label: "Последняя активность",
    source: "last_active",
    renderComponent: (last_active) => {
      const date = last_active ? formatDate(new Date(last_active)) : "";
      const time = last_active ? formatTime(new Date(last_active)) : "";

      return <DoubleText text={time} subText={date} />;
    },
  },
  {
    label: "Состояние",
    source: "at_work",
    renderComponent: (atWork) => {
      const text = atWork ? "Активно" : "Не активно";
      const statusType = atWork
        ? StatusBlockType.Success
        : StatusBlockType.Error;
      return <StatusBlock text={text} type={statusType} />;
    },
  },
  {
    label: "Cостояние",
    source: "active",
    renderComponent: (active, item) => {
      const text = active ? "В сети" : "Не в сети";
      const statusType = active
        ? StatusBlockType.Success
        : StatusBlockType.Error;
      return (
        <div className={styles.deviceStatus}>
          <Battery battery={item.charge} />
          <StatusBlock text={text} type={statusType} />
        </div>
      );
    },
  },
];

const filterConfig: FilterConfig<DevicesDescriptionForm> = [
  {
    type: "select",
    options: [
      { text: "В сети", value: "true" },
      { text: "Не в сети", value: "false" },
    ],
    name: "active",
    label: "Cостояние",
  },
  {
    type: "select",
    options: [
      { text: "В архиве", value: "true" },
      { text: "Не в архиве", value: "false" },
    ],
    name: "deleted",
    label: "Архив",
  },
];

export const StatusCheckerPage = () => {
  const [isModalOpen, showModal, hideModal] = useBoolState(false);

  const navigate = useNavigate();

  const { state, getDevices } = useDevices();
  const { page, limit, setPage, setLimit } = usePagination(100);
  const { setParams } = useUrlFilters();

  useEffect(() => {
    getDevices({ page, limit });
  }, [getDevices, limit, page]);

  const onSubmit = (data: DevicesDescriptionForm) => {
    setParams(data);
    paramsRef.current = data;
    getDevices(data);
  };

  // Create a ref to hold the latest filters
  const paramsRef = useRef({} as DevicesDescriptionForm);
  // const { lastMessage } = useWebSocket();

  // useEffect(() => {
  //   if (lastMessage && lastMessage.type == WebsocketUpdateType.d) {
  //     getDevices({ ...paramsRef.current,page, limit });
  //   }
  // }, [lastMessage, limit, page]);

  // Modify the useEffect to include filters in periodic fetches
  useEffect(() => {
    // Define a function to fetch data with the latest filters
    const fetchData = () => {
      getDevices({ ...paramsRef.current, page, limit });
    };

    // Fetch data immediately when page or limit changes
    fetchData();

    // Set up an interval to fetch data every 30 seconds with the latest filters
    const intervalId = setInterval(fetchData, 30000);

    // Clean up the interval when the component unmounts or dependencies change
    return () => clearInterval(intervalId);
  }, [getDevices, page, limit]);

  const devices = state.ids?.map((id) => state.devices[id]);

  return (
    <>
      <Block className={styles.statusChecker}>
        <div className={styles.header}>
          <h3>Подключенные устройства</h3>
          <Button icon={Arrow} onClick={showModal}>
            Добавить новое
          </Button>
        </div>
        <Table
          placeholder="Поиск по устройствам"
          withFilter
          filterProps={{
            filterConfig: filterConfig,
            onSubmit: onSubmit,
          }}
          config={config}
          onRowClick={(device) => {
            navigate(device.id);
          }}
          data={devices}
          loading={state.loading}
          setPage={setPage}
          setLimit={setLimit}
          limits={[100, 200, 300]}
          page={page}
          limit={limit}
          totalCount={state.totalCount}
        />
      </Block>
      <AddDeviceModal isOpen={isModalOpen} hide={hideModal} />
    </>
  );
};
